import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CountryDialogBoxComponent } from '../country-dialog-box/country-dialog-box.component';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { log } from 'console';

@Component({
  selector: 'app-country-data',
  templateUrl: './country-data.component.html',
  styleUrls: ['./country-data.component.scss']
})
export class CountryDataComponent implements OnInit {
  CountrySearchForm;
  APIService: any;
  dialogRef: MatDialogRef<any>;
  countryList: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  sortedData: any[];
  sortColumn: string = '';  // Track the currently sorted column
  sortDirection: string = 'asc';
  SessionNo: any;
  setIntervalSearch: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    window.scroll(0, 0);
    this.getCountryData();
    this.CountrySearchForm = this.fb.group({
      SearchString: new FormControl('')
    });
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }
  

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getCountryData();
    this.keypress();
  }

  getCountryData() {
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    this.umsService.getCountry(payload).subscribe(res => {
      this.spinner.hide();
      this.countryList = res.data;
      this.totalItems = res.data[0].TotalRecords;
    }, (ERROR: HttpErrorResponse) => {
      this.countryList = [];
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
  
  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.countryList = [];
    let payload = {}
    payload['SearchString'] = this.CountrySearchForm.value['SearchString'];
    payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.searchCountry(payload).subscribe(res => {
      if(res.status){
        this.countryList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }
      else{
        this.countryList = [];
        this.totalItems = 0;
      }
     
    }, (ERROR: HttpErrorResponse) => {
      this.countryList = [];
    });
    },1000)
    
  }

  addnewrecord() {

    const dialogRef = this.dialog.open(CountryDialogBoxComponent, {
      width: '75vh',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getCountryData();
      this.CountrySearchForm.controls['SearchString'].setValue('');
    });
  }

  editData(k) {
    const dialogRef = this.dialog.open(CountryDialogBoxComponent, {
      width: '75vh',
      data: { selected: k, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
      this.getCountryData();
      this.CountrySearchForm.controls['SearchString'].setValue('');
    });
  }

  deleteData(k) {
    const dialogRef = this.dialog.open(CountryDialogBoxComponent, {
      width: '75vh',
      data: { selected: k, key: "Delete" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getCountryData();
      this.CountrySearchForm.controls['SearchString'].setValue('');
    });
  }

  Print(){
    let submitpayload = this.CountrySearchForm.value;
    let payload1 = {}
    payload1['SearchString'] = submitpayload['SearchString'],
    payload1['MenuName'] ='Master-Country';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 111,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
}
